import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import ScoreBar from './ScoreBar'
import PdfBtn from './PdfBtn'
import NextBtn from './NextBtn'

import Core11 from './subSectionGuidance/Core11'
import Core12 from './subSectionGuidance/Core12'
import Finance21 from './subSectionGuidance/Finance21'
import Operations31 from './subSectionGuidance/Operations31'
import Operations32 from './subSectionGuidance/Operations32'
import Operations33 from './subSectionGuidance/Operations33'
import Operations34 from './subSectionGuidance/Operations34'
import Operations35 from './subSectionGuidance/Operations35'
import Operations36 from './subSectionGuidance/Operations36'
import Staff41 from './subSectionGuidance/Staff41'
import Staff42 from './subSectionGuidance/Staff42'
import Patient51 from './subSectionGuidance/Patient51'

import sections from '../data/sections'
import subSections from '../data/subSections'

const SectionGuidance = ({ nextBtnLink, score, section, subSection, subSectionScores }) => {
    useEffect(() => {
        document.getElementById("top-anchor").scrollIntoView({behavior:"smooth"})
    }, [])

    const findSubSectionScore = (scoreNum) => {
        if (!scoreNum) {
        return undefined
        } else if (scoreNum <= 50) {
        return {text: "Area for Improvement", className: "low-score"}
        } else if (scoreNum <= 75) {
        return {text: "Almost Ready", className: "medium-score"}
        } else {
        return {text: "Ready", className: "high-score"}
        }
    }

    const matchSubSectionComponent = (subSection) => {
        const subSectionScore = findSubSectionScore(subSectionScores[subSection].score)
        switch (subSection) {
            case '11':
                return <Core11 score={subSectionScore}/>
            case '12':
                return <Core12 score={subSectionScore}/>
            case '21':
                return <Finance21/>
            case '31':
                return <Operations31 score={subSectionScore}/>
            case '32': 
                return <Operations32 score={subSectionScore}/>
            case '33':
                return <Operations33 score={subSectionScore}/>
            case '34':
                return <Operations34 score={subSectionScore}/>
            case '35':
                return <Operations35 score={subSectionScore}/>
            case '36':
                return <Operations36 score={subSectionScore}/>
            case '41':
                return <Staff41 score={subSectionScore}/>
            case '42':
                return <Staff42 score={subSectionScore}/>
            case '51':
                return <Patient51/>
            case '52':
                return <Patient51/>
            default:
                return undefined
        }
    }

    const startingSubSection = matchSubSectionComponent(subSection)
    const subSectionData = subSections.filter((subSection) => subSection.secId === section.secId)

    const [currentSubSection, setCurrentSubSection] = useState(startingSubSection)

    return (
        <div className="grid-container page wide-score">
            <div className="clear"></div>

            <div className="grid-x" style={{marginBottom: '1rem'}}>
                <div className="cell medium-12 large-5">
                    <div className="guidance-intro">
                        <div className={`icon ${section.secId}-icon`} dangerouslySetInnerHTML={section.icon}></div>
                        <h3 className="bold">{ `${section.number}. ${section.title}` }</h3>
                    </div>
                </div>

                <div className="cell medium-12 large-7">
                    <div className="btn-group btn-group--guidance">
                        <PdfBtn link="/Telehealth-Readiness-Guidance.pdf" btnText="Download All Guidance"></PdfBtn>
                        <NextBtn nextLabel={nextBtnLink === "/results" ? "View My Results" : "Next Concept"} nextLink={nextBtnLink}></NextBtn>
                    </div>
                </div>
            </div>

            <div className="score-margin">
                {!!score && <ScoreBar extraText="Overall concept result: " score={score} />}
            </div>

            <h3 className="bold center">Supporting Guidance</h3>
            { ((section.secId !== 'finance') && (section.secId !== 'patient')) &&
                <div className="subsection-toc center blue-line">
                    <p>Click a key component to view the related guidance:</p>
                    
                    <ul className="subsection-names">
                        { subSectionData.map((subSection) => 
                            <li 
                                className="underline" 
                                onClick={() => {
                                    setCurrentSubSection(matchSubSectionComponent(subSection.subSecId))
                                    document.getElementById("subsection-anchor").scrollIntoView({behavior:"smooth"})
                                }} 
                                key={subSection.subSecId}
                            >
                                {`${section.number}${subSection.number}. ${subSection.title}`}
                            </li>
                        )}
                    </ul>
                </div>
            }
            
            <div id="subsection-anchor"></div>
            {currentSubSection}
        </div>
    )
}

const mapStateToProps = (state, props) => {
    const section = sections.find((section) => section.secId === props.match.params.secId)
    const sectionIndex = sections.indexOf(section)
    const nextSection = sections[sectionIndex +1]

    return {
        nextBtnLink: section.secId === "patient" ? "/results" : `/menu/${nextSection.secId}/`,
        score: state.scores.sections[section.secId],
        section,
        subSection: props.match.params.subSecId,
        subSectionScores: state.scores.subSections
    }
}

export default connect(mapStateToProps)(SectionGuidance)



// WEBPACK FOOTER //
// ./src/components/SectionGuidance.js